import React from "react"
import isPlainObject from "lodash/isPlainObject"
import { Provider } from "react-redux"
import { createStore, combineReducers } from "redux"
import propsflow from "propsflow"

const DEFAULT_STATE = {}

const rootReducer = function rootReducer(state = DEFAULT_STATE) {
  return state
}

const initial = () => ({
  createStore: function adaptiveCreateStore(reducers, ...tail) {
    const combinedReducers = isPlainObject(reducers)
      ? combineReducers(reducers)
      : reducers

    return createStore(combinedReducers, ...tail)
  },
})

const initStore = () => ({ createStore }) => {
  // eslint-disable-next-line no-underscore-dangle
  const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  )

  return {
    store,
  }
}

const wrapApp = () => ({ App, store }) => {
  const NextApp = () => (
    <Provider store={store}>
      <App />
    </Provider>
  )

  return {
    App: NextApp,
  }
}

export default propsflow(initial, initStore, wrapApp)
